export const ADD_FILES = 'ADD_FILES'
export const ADD_FILE = 'ADD_FILE'
